export default [
    "1",
    "2",
    "3",
    "4",
    "More than 4"
]